import {addDays, subDays} from 'date-fns'
import {
    format,
    isWeekend} from "date-fns";
import {getBookingConfig} from "../data/price";

export class DeliveryService {

    public static isWorkingDate(date: Date) {
        const bookingConfig = getBookingConfig();
        const dateString = format(date,"yyyy-MM-dd");
        if(bookingConfig.deliveryHolidays.includes(dateString)){
            return false;
        }
        if(bookingConfig.globalHolidays.includes(dateString)){
            return false;
        }
        return !isWeekend(date);
    };

    protected static findWorkingDateByCallback(date: Date, modifierFn: (date: Date, days: number) => Date) {
        let possibleDate = modifierFn(date, 1);

        while (!(DeliveryService.isWorkingDate(possibleDate))) {
            possibleDate = modifierFn(possibleDate, 1);
        }
        return possibleDate;
    }

    public static findNextWorkingDate(date: Date) {
        return DeliveryService.findWorkingDateByCallback(date, addDays);
    }

    public static findPreviousWorkingDate(date: Date) {
        return DeliveryService.findWorkingDateByCallback(date, subDays);
    }

    public static addBusinessDays(date: Date, numBusinessDays: number) {
        let newDate = new Date(date);
        while (numBusinessDays > 0) {
            newDate = DeliveryService.findNextWorkingDate(newDate);
            numBusinessDays -= 1;
        }
        while (numBusinessDays < 0) {
            newDate = DeliveryService.findPreviousWorkingDate(newDate);
            numBusinessDays += 1;
        }
        return newDate;
    }

    public static subtractBusinessDays(date: Date, numBusinessDays: number) {
        let newDate = new Date(date);
        while (numBusinessDays > 0) {
            newDate = DeliveryService.findPreviousWorkingDate(newDate);
            numBusinessDays -= 1;
        }
        while (numBusinessDays < 0) {
            newDate = DeliveryService.findNextWorkingDate(newDate);
            numBusinessDays += 1;
        }
        return newDate;
    }
}
